export const header_links_routes = [
    { path: process.env.NEXT_PUBLIC_BASE_URL!.replace("https://projects.", "https://"), label: "Home" },
    { path: process.env.NEXT_PUBLIC_BASE_URL!.replace("https://projects.", "https://") + "/about", label: "About" },
    {
        path: process.env.NEXT_PUBLIC_BASE_URL!,
        label: "Projects",
    },
    // { path: "/blog", label: "Blog" },
    { path: process.env.NEXT_PUBLIC_BASE_URL!.replace("https://projects.", "https://") + "/contact", label: "Contact" },
];

// { path: "/IT-songs", label: "IT songs" },

// { path: "/IT-songs", label: "IT songs" },
